/**
 * Body `code` the Prompt Bridge spending-limit middleware returns with its 429
 * (`ErrorCodes.PromptBridge.SPENDING_LIMIT_EXCEEDED`). Duplicated as a literal because
 * `shared/nodejs` is Node-only and must never reach the browser bundle; `useAssistantConversation`
 * matches this same constant. Every other Prompt Bridge 429 (API rate limit `common-010`,
 * concurrent streams `prompt-bridge-061`, provider rate limiting on issue reports) is NOT a spending
 * limit and must not raise the spending-limit notification.
 */
export const PROMPT_BRIDGE_SPENDING_LIMIT_ERROR_CODE = 'prompt-bridge-054';
